import { STOP } from '@/state/types/pageflip'
import { routesIndex } from '@/state/routesMap'

export default (state = { animated: false, dir: '' }, action = {}) => {
  switch (action.type) {
    case STOP:
      return { ...state, ...{ animated: false } }
    default:
      if (!action.meta || !action.meta.location) {
        return state
      }

      const type = action.type
      const prevType = action.meta.location.prev.type

      if (!prevType || type === prevType) {
        return state
      }
      return {
        ...state,
        ...{
          animated: true,
          dir: routesIndex.indexOf(type) > routesIndex.indexOf(prevType) ? 'next' : 'back',
        },
      }
  }
}



// WEBPACK FOOTER //
// ./state/reducers/pageflip.js